import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./css/layout-custom.css";

import { ConfigProvider } from 'antd';

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider theme={{ hashed: false }}>
    <App />
  </ConfigProvider>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
